import { Component } from '@angular/core';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_models/globals';
import { SupportSellerVacationService } from './seller-vacation.service';
import { SellerOnVacation } from './_models/sellerOnVacation';
import { UserService } from 'app/_services/user.service';
import { RolesIdsEnum } from 'app/_models/roles';

declare const isEmpty: any;

@Component({
    selector: 'app-seller-vacation', templateUrl: './seller-vacation.component.html', styleUrls: ['./seller-vacation.component.scss'],
    standalone: false
})
export class SupportSellerVacationComponent {
    filter: string = '';
    sellersOnVacation: SellerOnVacation[] = [];
    sellersOnVacationFiltered: SellerOnVacation[] = [];
    isList: boolean = true;
    baseUrl: string;

    constructor(public supportSellerVacationService: SupportSellerVacationService, private userService: UserService, private route: ActivatedRoute, private notificationService: NotificationService, private ngxLoader: NgxUiLoaderService, private globals: Globals) { }

    ngOnInit() {
        this.baseUrl = this.userService.userRole() === RolesIdsEnum.GestorDePecas ? 'gestor-peca/painel-vendedores' : 'suporte/manutencao';

        let urlSegments = this.route.snapshot.url;
        let param_new_product = urlSegments.some(segment => segment.path === 'novo');

        if (param_new_product) {
            this.isList = false;
            return;
        }

        this.getSellersOnVacation();
    }

    getSellersOnVacation() {
        this.ngxLoader.startLoader('loader-principal');

        this.supportSellerVacationService.getSellersOnVacation().subscribe({
            next: (response: ApiResponseModel<SellerOnVacation[]>) => {
                this.sellersOnVacation = response.result;
                this.handleSellersOnVacationList();

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
                this.notificationService.showErrorToastr(this.globals.translate('support.manage-holdings.messages.error.list'));
            }
        });
    }

    goBackToList(shouldReload: boolean = false) {
        if (shouldReload || this.sellersOnVacation.length === 0)
            this.getSellersOnVacation();

        this.isList = true;
        history.pushState({}, '', `${this.baseUrl}/vendedores-de-ferias`);
    }

    onSearch($event: string) {
        if (isEmpty(this.sellersOnVacation))
            return [];

        this.filter = $event;

        this.sellersOnVacationFiltered = this.filterSellersOnVacationList();
    }

    openCreateVacation() {
        history.pushState({}, '', `${this.baseUrl}/vendedores-de-ferias/novo` );
        this.isList = false;
    }

    private filterSellersOnVacationList() {
        if (isEmpty(this.sellersOnVacation))
            return [];

        if (isEmpty(this.filter))
            return this.sellersOnVacation;

        var term: string = this.filter.toLowerCase();

        return this.sellersOnVacation.filter(holding => {
            return holding.sellerId.toString().startsWith(term)
                || holding.sellerOnVacation.toLowerCase().includes(term)
                || holding.substituteSeller.toLowerCase().includes(term)
                || holding.holdingName.toLowerCase().includes(term);
        });
    }

    private handleSellersOnVacationList() {
        this.sellersOnVacation.map(seller => {
            seller.startDate = new Date(seller.startDate);
            seller.startDate.setHours(seller.startDate.getHours() + 3);

            seller.endDate = new Date(seller.endDate);
            seller.endDate.setHours(seller.endDate.getHours() + 3);
        })

        this.sellersOnVacationFiltered = this.filterSellersOnVacationList();
    }
}
